module.exports = __webpack_public_path__ + "index/img/infoPhone.82ee50cd.png";